import { ErrorMessage, Field, Form, Formik } from 'formik'
import Input from '../../../components/_shared/Input/Input'
import { Link } from 'react-router-dom'
import { loginValidationSchema } from './validationSchema'
import { Spinner } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { useState, useEffect } from 'react'
import Splash from '../splashScreen/Splash'
import { useMutation } from '@tanstack/react-query'
import { authLogin } from '../_redux/authAPI'
import { login } from '../_redux/authSlice'
import APIErrorComponent from '../../../components/_shared/Error/APIErrorComponent'
import toasters from '../../../../utils/toasters/Toasters'
import '../style.css'
import { LuEye } from 'react-icons/lu'
import { LuEyeOff } from 'react-icons/lu'
import styles from '../../../components/_shared/Error/style.module.css'


const Login = (props) => {
    const dispatch = useDispatch()

    // password visibility
    const [showPassword, setShowPassword] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }

    const {
        isLoading,
        mutate: loginMutate,
    } = useMutation(authLogin, {
        onSuccess: (data) => {
           dispatch(login(data))
           setErrorMessage("") 
        },
        onError: (error) => {
            const msg = error?.response?.data?.message || "Invalid credentials"
            setErrorMessage(msg)
            toasters({ type: 'error', message: msg })
        },
    })

    return (
        <div className="Auth-form-container">
            <Formik
                initialValues={{
                    username_tx: '',
                    hash_tx: '',
                }}
                validationSchema={loginValidationSchema}
                onSubmit={(values, { setTouched }) => {
                    loginMutate(values)
                    setTouched({})
                }}
            >
                {({ handleChange }) => (
                    <Form className="Auth-form">
                        <h1 className="Auth-form-title text-white px-4 py-5">
                            Sign In
                        </h1>
                        <div className="Auth-form-content p-4">
                        {errorMessage && (
                            <div className={styles.errorContainer}>
                                <div className={styles.errorMessage}>
                                    <p className={styles.errorMessage}>{errorMessage}</p>
                                </div>
                            </div>  
                             )}  
                            <div>
                                <Field
                                    name="username_tx"
                                    labelText={`Username`}
                                    type="text"
                                    placeholder="User"
                                    component={Input}
                                    onChange={(e) => {
                                        setErrorMessage("")
                                        handleChange(e)
                                    }}
                                />
                                <p className="text-danger errorMsg">
                                    <ErrorMessage
                                        className="m-0 p-0"
                                        name="username_tx"
                                    />
                                </p>
                            </div>

                            <div className="mt-3 position-relative">
                                <Field
                                    iconVisibility={false}
                                    name="hash_tx"
                                    labelText="Password"
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="********"
                                    component={Input}
                                    onChange={(e) => {
                                        setErrorMessage("")
                                        handleChange(e)
                                    }}
                                />
                                <div className="frgtPswd">
                                    <Link
                                        to="/forgotPassword"
                                        className="text-decoration-none fw-bold "
                                    >
                                        Forgot Password
                                    </Link>
                                </div>
                                <span
                                    onClick={togglePasswordVisibility}
                                    className="eye"
                                >
                                    {showPassword ? <LuEyeOff /> : <LuEye />}
                                </span>
                            </div>
                            <p className="text-danger errorMsg">
                                <ErrorMessage
                                    className="m-0 p-0"
                                    name="hash_tx"
                                />
                            </p>
                            <div className="d-grid gap-2 mt-3">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    Sign in
                                    {isLoading && (
                                        <Spinner
                                            className="ms-2"
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    )}
                                </button>
                            </div>
                            <p className="forgot-password text-center mt-3">
                                If you don't have account?{' '}
                                {/* Registration lives on the marketing site,
                                    not in this app, so this is a plain anchor
                                    rather than a router Link - `to=""` just
                                    re-navigated to /login and looked dead. */}
                                <a
                                    href="https://weatec.com/registration/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none fw-bold "
                                >
                                    Sign up
                                </a>
                            </p>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default Login